import { render, staticRenderFns } from "./CustomerAddressPreview.vue?vue&type=template&id=0d4b66bc&"
import script from "./CustomerAddressPreview.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel})
